<template>
    <vs-card>
      <div class="flex flex-wrap justify-between items-center mb-4">
        <h4>Files</h4>
        <vs-button @click="handleAdd()">Add</vs-button>
      </div>
      <div class="cstm_vuexy_table table-responsive">
        <table class="w-full">
          <thead>
            <tr>
              <th>Type</th>
              <th>File Name</th>
              <th>Size</th>
              <th style="width: 50px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(eachData, index) in localvalue" :key="index">
              <td>
                <div class="inline-flex items-center">
                    <i
                  v-if="eachData.file.file_type.includes('application/pdf')"
                  class="material-icons"
                  style="color: teal"
                  >picture_as_pdf</i
                >
                <i
                v-else-if="video_array.includes(eachData.file.file_type)"
                class="material-icons"
                style="color: teal"
                >ondemand_video</i
              >
              <i
                v-else-if="image_array.includes(eachData.file.file_type)"
                class="material-icons"
                style="color: teal"
                >picture_in_picture</i
              >
              <i
                v-else-if="audio_array.includes(eachData.file.file_type)"
                class="material-icons"
                style="color: teal"
                >audiotrack</i
              >
                <svg
                  v-else-if="
                    eachData.file.file_type.includes('doc') ||
                    eachData.file.file_type.includes('docx') || eachData.file.file_type.includes('xlsx')
                  "
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="40"
                  height="40"
                  viewBox="0 0 172 172"
                  style="fill: #000000"
                >
                  <g
                    fill="none"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                    style="mix-blend-mode: normal"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#9b59b6">
                      <path
                        d="M86,21.5l-71.66667,14.33333v100.33333l71.66667,14.33333zM100.33333,35.83333v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h43v14.33333h-43v14.33333h50.16667c3.956,0 7.16667,-3.21067 7.16667,-7.16667v-86c0,-3.956 -3.21067,-7.16667 -7.16667,-7.16667zM23.61361,59.44694h11.00195l3.52734,24.92937c0.25083,1.49783 0.44657,3.5382 0.50391,6.06087h0.18197c0.05733,-1.84183 0.31869,-3.94335 0.75586,-6.20085l4.52116,-24.78939h13.39551l4.18522,24.70541c0.25083,1.29716 0.42955,3.20361 0.61589,5.66894h0.13997c0.05733,-1.9135 0.24624,-3.89923 0.48991,-5.94889l3.42936,-24.42546h10.34408l-9.91016,53.10612h-9.42025l-6.29883,-28.38672c-0.31533,-1.77017 -0.48823,-3.76307 -0.5599,-5.9489h-0.12598c-0.129,2.38651 -0.37771,4.37223 -0.68587,5.9489l-6.4248,28.38672h-9.79818z"
                      ></path>
                    </g>
                  </g>
                </svg>
  
                  <span class="pl-2">
                    {{
                    getFileType(eachData.file.file_type)
                  }}</span>
                </div>
              </td>
              <td>
                {{ eachData.description }}
              </td>
              <td>
                {{ eachData.file.size }}
              </td>
              <td>
                <vs-dropdown>
                  <vs-button
                    class="btn-drop"
                    type="flat"
                    icon="more_vert"
                  ></vs-button>
                  <vs-dropdown-menu>
                    <vs-dropdown-item
                      v-if="eachData.file.file_path"
                      @click="
                        downloadItem(
                          eachData.file.file_path,
                          eachData.file.file_name
                        )
                      "
                    >
                      Download
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="preview(eachData)">
                      Preview
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="editFile(eachData)">
                      Edit
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="showDeletePopUp(eachData, index)">
                      Delete
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <vs-popup
        classContent="popup-example"
        title="Add File"
        :active.sync="addpopup"
      >
        <form data-vv-scope="file">
          <vs-row>
            <label>Name</label>
            <vs-input
              v-model="description"
              style="width: 100%"
              v-validate="'required'"
              name="name"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            />
  
            <div
              v-if="errors.has('file.name')"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("file.name") }}
            </div></vs-row
          >
          <vs-row>
            <file-upload-component
              :addpopup="addpopup"
              @getFileId="getFileId"
              types="File"
              :file_repository_id="repository_id"
            ></file-upload-component>
          </vs-row>
        </form>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
          <vs-button type="border" color="danger" @click="handleAddCancel"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
      <vs-popup
        classContent="popup-example"
        title="Preview"
        :active.sync="previewPopup"
      >
        <form data-vv-scope="file">
          <vs-row v-if="file_type.includes('pdf')">
          <pdf :src="file_url"></pdf>
        </vs-row>
        <vs-row v-else-if="image_array.includes(file_type)">
          <img :src="file_url" />
        </vs-row>
        <vs-row v-else-if="audio_array.includes(file_type)">
          <audio class="w-full" controls>
            <source :src="file_url" :type="file_type" />
          </audio>
        </vs-row>
        <vs-row v-else-if="video_array.includes(file_type)">
          <video width="100%" height="500px" controls :src="file_url">
          </video>
        </vs-row>
        <vs-row  v-else>
           Preview not available!!!
          </vs-row>
        </form>
      </vs-popup>
      <vs-popup
        classContent="popup-example"
        title="Edit Name"
        :active.sync="Editpopup"
      >
        <form data-vv-scope="file_edit">
          <vs-row>
            <label>Name</label>
            <vs-input
              v-model="edit.description"
              style="width: 100%"
              v-validate="'required'"
              name="name"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            />
            <div
              v-if="errors.has('file_edit.name')"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("file_edit.name") }}
            </div>
          </vs-row>
        </form>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click.prevent="handleEdit">Save</vs-button>
          <vs-button type="border" color="danger" @click="handleEditCancel"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
      <vs-popup
        classContent="popup-example"
        title="Please Confirm"
        :active.sync="showDeletePopUpBool"
      >
        <h4>Are you sure to delete this file?</h4>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click="remove(deleteItem, deleteIndex)">Confirm</vs-button>
          <vs-button type="border" color="danger" @click="showDeletePopUpBool = false"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
    </vs-card>
  </template>
  
<script>
import pdf from 'vue-pdf'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import axios from 'axios'
import { SinglefileUploadApi, SinglefileDeleApi } from '@/api/student.js'
import FileUploadComponent from '@/views/pages/leads/SinglefileUpload.vue'
import { repository } from '@/mixins/repository.js'
export default {
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false
  
      this.getModulePermission('Students')
    }
    this.getRepositoryId(this.module_id)
  },
  computed: {
    localvalue: {
      get () {
        return this.clientDetails.files
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  components: {
    FileUploadComponent,
    pdf
  },
  mixins: [repository, PermissionMiddleware],
  props: {
    module_id: {
      type: Number,
      required: true
    },
    clientDetails: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      client_id:this.$route.params.client_id,
      video_array:['mpeg', 'mp4', 'mpg', 'mpe', 'qt', 'mov', 'mxu', 'm4u', 'flv', 'asf', 'asx', 'wmv', 'wm', 'wmx', 'avi', 'ogv', 'movie'],
      audio_array:['au', 'snd', 'mid', 'midi', 'kar', 'mpga', 'mp2', 'mp3', 'aif', 'aiff', 'aifc', 'm3u', 'wma', 'wax', 'ram', 'ra', 'wav'],
      image_array:['bmp', 'cgm', 'gif', 'ief', 'jpeg', 'jpg', 'jpe', 'png', 'svg', 'tiff', 'tif', 'djvu', 'djv', 'wbmp', 'ras', 'ico', 'pnm', 'pbm', 'pgm', 'ppm', 'rgb', 'xbm', 'psd', 'xpm', 'xwd'],
      Editpopup: false,
      addpopup: false,
      description: '',
      file_id: '',
      previewPopup: false,
      file_url: '',
      file_type: '',
      edit: {},
      files_info: '',
      showDeletePopUpBool: false,
      deleteItem: {},
      deleteIndex: null
    }
  },
  methods: {
    showDeletePopUp (eachData, index) {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.deleteItem = eachData
      this.deleteIndex = index
      this.showDeletePopUpBool = true
    },
    handleAdd () {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.addpopup = true
    },
    getFileType (type) {
      return type.includes('image') ? 'IMAGE' : type.includes('video') ? 'VIDEO' : type.includes('application/pdf') ? 'PDF' : type.includes('audio') ? 'AUDIO' : type.includes('doc') ? 'DOC' :
        type.includes('docx') ? 'DOCX' :  type.includes('xlsx') ? 'Excel' : type.toUpperCase()
    },
    downloadItem (url, label) {
      axios
        .get(url, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'mime' })
  
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${label}.${
            url.split('.')[url.split('.').length - 1]
          }`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    async remove (item, indextr) {
      try {
        const payload = {
          client_file_id: item.id
        }
        await SinglefileDeleApi(payload)
        this.showSuccessMessage(
          'Success',
          'File removed successfully',
          'success'
        )
        this.localvalue.splice(indextr, 1)
        this.showDeletePopUpBool = false
      } catch (e) {
        this.showSuccessMessage('Warning', 'Something went wrong', 'warning')
      }
    },
    getFileId (file_id) {
      this.file_id = file_id
    },
    async handleAddCancel () {
      this.addpopup = false
      this.description = ''
      this.file_id = ''
    },
    async handleEditCancel () {
      this.Editpopup = false
    },
    async handleSave () {
      try {
        const validateParent = await this.$validator.validateAll('file')
        if (validateParent && this.file_id) {
          const payload = {
            user_file_id: null,
            client_user_id: this.client_id,
            description: this.description,
            file_id: this.file_id,
            customer_id: localStorage.getItem('customer_id')
          }
          const fileResponse = await SinglefileUploadApi(payload)
          this.addpopup = false
          this.showSuccessMessage(
            'Success',
            'File added successfully',
            'success'
          )
          this.localvalue.push(fileResponse.data.data.client_file)
          this.description = ''
          this.file_id = ''
        } else if (this.file_id === '') {
          this.showSuccessMessage('Warning', 'Please upload a file', 'warning')
        } else {
          this.showSuccessMessage(
            'Warning',
            'Name field is required',
            'warning'
          )
        }
      } catch (e) {
        this.showSuccessMessage('Warning', 'Something went wrong', 'warning')
      }
    },
    async handleEdit () {
      try {
        const validateParent = await this.$validator.validateAll('file_edit')
        if (validateParent) {
          const payload = {
            user_file_id: this.edit.id,
            client_user_id: this.client_id,
            description: this.edit.description,
            file_id: this.edit.file_id,
            customer_id: localStorage.getItem('customer_id')
          }
          const fileResponse = await SinglefileUploadApi(payload)
          this.Editpopup = false
          this.showSuccessMessage(
            'Success',
            'Name updated successfully',
            'success'
          )
        } else {
          this.showSuccessMessage(
            'Warning',
            'Name field is required',
            'warning'
          )
        }
      } catch (e) {
        this.showSuccessMessage('Warning', 'Something went wrong', 'warning')
      }
    },
    async preview (item) {
      this.file_url = item.file.file_path
      this.file_type = item.file.file_type
      this.previewPopup = true
    },
    async editFile (item) {
      if (this.clientDetails.basic_details.active_user === '0') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as student is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.Editpopup = true
      this.edit = item
    }
  }
}
</script>